import HistoricalReportsContainer from "@shared-containers/HistoricalReportsContainer";
import { StyledRootBox } from "./style";

const HistoricalReports = () => {
  return (
    <StyledRootBox>
      <HistoricalReportsContainer />
    </StyledRootBox>
  );
};

export default HistoricalReports;
